import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";

interface ChatMessage {
  from: "User" | "Bot";
  message: string;
}

export interface Conversation {
  initialized: boolean;
  messages: ChatMessage[];
}

export const useVenturiJobChatQuery = (chatId: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.venturiJobChat(chatId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: true,
    /*async*/ queryFn() {
      const placeholder: Conversation = {
        initialized: false,
        messages: [
          {
            from: "Bot",
            message:
              "<strong>I'm getting that Job Opening so we can get started! 👋</strong>",
          },
        ],
      };

      return placeholder;
    },
  });

  return {
    venturiJobChatLoading: isLoading,
    venturiJobChat: data ?? null,
    venturiJobChatError: error ?? null,
  };
};
